import { createElement } from "@wordpress/element";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useEffect, useMemo, useRef } from 'react';
var clamp = function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
};
var posFrac = function posFrac(p) {
  return p === 'left' ? 0.25 : p === 'right' ? 0.75 : 0.5;
};
var InteractiveDNA = function InteractiveDNA(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 3 : _ref$aspectRatio,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'transparent' : _ref$background,
    colour = _ref.colour,
    _ref$dotColorA = _ref.dotColorA,
    dotColorA = _ref$dotColorA === void 0 ? colour == 'light' ? '#68cbe2' : '#0052FF' : _ref$dotColorA,
    _ref$dotColorB = _ref.dotColorB,
    dotColorB = _ref$dotColorB === void 0 ? colour == 'light' ? '#2eddc2' : '#2600BB' : _ref$dotColorB,
    _ref$dotSize = _ref.dotSize,
    dotSize = _ref$dotSize === void 0 ? 3 : _ref$dotSize,
    _ref$amplitudeBase = _ref.amplitudeBase,
    amplitudeBase = _ref$amplitudeBase === void 0 ? 0.19 : _ref$amplitudeBase,
    _ref$turns = _ref.turns,
    turns = _ref$turns === void 0 ? 2.5 : _ref$turns,
    _ref$rotationDeg = _ref.rotationDeg,
    rotationDeg = _ref$rotationDeg === void 0 ? -8 : _ref$rotationDeg,
    _ref$rungs = _ref.rungs,
    rungs = _ref$rungs === void 0 ? 50 : _ref$rungs,
    _ref$rungDotCount = _ref.rungDotCount,
    rungDotCount = _ref$rungDotCount === void 0 ? 12 : _ref$rungDotCount,
    _ref$rungDotScale = _ref.rungDotScale,
    rungDotScale = _ref$rungDotScale === void 0 ? 0.55 : _ref$rungDotScale,
    _ref$rungColor = _ref.rungColor,
    rungColor = _ref$rungColor === void 0 ? colour == 'light' ? '#FFFFFF' : '#8a96bf' : _ref$rungColor,
    _ref$breakIntensity = _ref.breakIntensity,
    breakIntensity = _ref$breakIntensity === void 0 ? 3 : _ref$breakIntensity,
    _ref$springK = _ref.springK,
    springKProp = _ref$springK === void 0 ? 0.0075 : _ref$springK,
    _ref$damping = _ref.damping,
    dampingProp = _ref$damping === void 0 ? 0.85 : _ref$damping,
    _ref$bokehEnabled = _ref.bokehEnabled,
    bokehEnabled = _ref$bokehEnabled === void 0 ? true : _ref$bokehEnabled,
    _ref$bokehCount = _ref.bokehCount,
    bokehCount = _ref$bokehCount === void 0 ? 48 : _ref$bokehCount,
    _ref$bokehColor = _ref.bokehColor,
    bokehColor = _ref$bokehColor === void 0 ? '#ffffff' : _ref$bokehColor,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'center' : _ref$position;
  var wrapperRef = useRef(null);
  var canvasRef = useRef(null);
  var rafRef = useRef(null);
  var mouseRef = useRef({
    x: 0,
    y: 0,
    active: false
  });
  var prefersReducedMotion = useMemo(function () {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);
  useEffect(function () {
    var canvas = canvasRef.current;
    var wrapper = wrapperRef.current;
    if (!canvas || !wrapper) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    // ---------- sizing ----------
    var resize = function resize() {
      var parentW = width !== null && width !== void 0 ? width : wrapper.clientWidth || 800;
      var parentH = height !== null && height !== void 0 ? height : wrapper.clientHeight || 400;
      var parentAR = parentW / Math.max(1, parentH);
      var cssW, cssH;
      if (parentAR >= aspectRatio) {
        cssH = parentH;
        cssW = Math.min(parentW, cssH * aspectRatio);
      } else {
        cssW = parentW;
        cssH = Math.min(parentH, cssW / aspectRatio);
      }
      var dpr = Math.max(1, Math.floor(window.devicePixelRatio || 1));
      canvas.width = Math.floor(cssW * dpr);
      canvas.height = Math.floor(cssH * dpr);
      canvas.style.width = cssW + 'px';
      canvas.style.height = cssH + 'px';
      // Normalize to CSS pixels for drawing math
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var left = (parentW - cssW) / 2;
      var top = (parentH - cssH) / 2;
      canvas.style.position = 'absolute';
      canvas.style.left = left + 'px';
      canvas.style.top = top + 'px';
    };
    var cssW = function cssW() {
      return canvas.clientWidth;
    };
    var cssH = function cssH() {
      return canvas.clientHeight;
    };
    var dots = [];
    var bokeh = [];
    var baseRepelRadiusFactor = 0.25;
    var baseRepelStrength = 0.85;
    var springK = springKProp;
    var damping = dampingProp;
    var rebuildDNA = function rebuildDNA() {
      var W = cssW();
      var H = cssH();
      var amplitude = Math.min(W, H) * amplitudeBase;
      dots = [];
      var total = clamp(rungs !== null && rungs !== void 0 ? rungs : dotSize === 3 ? 50 : 30, 20, 200);
      for (var i = 0; i < total; i++) {
        var t = i / (total - 1);
        var x = t * W; // LOCAL coordinates (no baked offset)
        var theta = t * turns * Math.PI * 2;
        var yCenter = H * 0.5;
        var depthA = Math.cos(theta);
        var yA = yCenter + amplitude * Math.sin(theta);
        dots.push({
          bx: x,
          by: yA,
          x: x,
          y: yA,
          vx: 0,
          vy: 0,
          strand: 0,
          depth: depthA,
          tFrac: t
        });
        var depthB = Math.cos(theta + Math.PI);
        var yB = yCenter + amplitude * Math.sin(theta + Math.PI);
        dots.push({
          bx: x,
          by: yB,
          x: x,
          y: yB,
          vx: 0,
          vy: 0,
          strand: 1,
          depth: depthB,
          tFrac: t
        });
        var count = clamp(Math.floor(rungDotCount), 0, 64);
        if (count > 0) {
          for (var k = 1; k <= count; k++) {
            var tau = k / (count + 1);
            var ry = yA * (1 - tau) + yB * tau;
            var rDepth = depthA * (1 - tau) + depthB * tau;
            dots.push({
              bx: x,
              by: ry,
              x: x,
              y: ry,
              vx: 0,
              vy: 0,
              strand: 2,
              depth: rDepth,
              tFrac: t,
              tau: tau
            });
          }
        }
      }
    };
    var rebuildBokeh = function rebuildBokeh() {
      if (!bokehEnabled) {
        bokeh = [];
        return;
      }
      var W = cssW();
      var H = cssH();
      var count = clamp(Math.floor(bokehCount), 0, 200);
      bokeh = new Array(count).fill(0).map(function () {
        var z = Math.random();
        var r = (0.001 + z * 0.004) * W;
        var speed = (0.05 + z * 0.25) * (Math.random() < 0.5 ? 1 : -1);
        var angle = Math.random() * Math.PI * 2;
        var vx = Math.cos(angle) * speed;
        var vy = Math.sin(angle) * speed;
        return {
          x: Math.random() * W,
          y: Math.random() * H,
          r: r,
          vx: vx,
          vy: vy,
          z: z
        };
      });
    };

    // init
    resize();
    rebuildDNA();
    rebuildBokeh();
    var handleResize = function handleResize() {
      resize();
      rebuildDNA();
      rebuildBokeh();
    };
    var ro = null;
    if (typeof window.ResizeObserver !== 'undefined') {
      ro = new window.ResizeObserver(function () {
        return handleResize();
      });
      ro.observe(wrapper);
    }
    window.addEventListener('resize', handleResize);
    var angle = rotationDeg * Math.PI / 180;
    var cosA = Math.cos(angle);
    var sinA = Math.sin(angle);

    // DRAW: 1) Translate(dx,0)  2) Rotate around canvas center
    // INVERSE(pointer): 1) Subtract dx  2) Un-rotate around canvas center
    var screenToLocal = function screenToLocal(px, py) {
      var W = cssW();
      var H = cssH();
      var cx = W * 0.5;
      var cy = H * 0.5;
      var dx = W * (posFrac(position) - 0.5);

      // ---- FIXED ORDER ----
      // 1) undo pre-rotation screen translation
      var sx = px - dx;
      var sy = py;

      // 2) undo rotation about center
      var rx = sx - cx;
      var ry = sy - cy;
      var lx = rx * cosA + ry * sinA + cx;
      var ly = -rx * sinA + ry * cosA + cy;
      return {
        x: lx,
        y: ly
      };
    };

    // Interaction
    var onMove = function onMove(e) {
      var rect = canvas.getBoundingClientRect();
      var sx = 0,
        sy = 0;
      if (e instanceof TouchEvent) {
        var t = e.touches[0] || e.changedTouches[0];
        if (!t) return;
        sx = t.clientX - rect.left;
        sy = t.clientY - rect.top;
      } else {
        var m = e;
        sx = m.clientX - rect.left;
        sy = m.clientY - rect.top;
      }
      var p = screenToLocal(sx, sy);
      mouseRef.current.x = p.x;
      mouseRef.current.y = p.y;
      mouseRef.current.active = true;
    };
    var onLeave = function onLeave() {
      return mouseRef.current.active = false;
    };
    canvas.addEventListener('mousemove', onMove);
    canvas.addEventListener('mouseleave', onLeave);
    canvas.addEventListener('touchstart', onMove, {
      passive: true
    });
    canvas.addEventListener('touchmove', onMove, {
      passive: true
    });
    canvas.addEventListener('touchend', onLeave);
    canvas.addEventListener('touchcancel', onLeave);

    // Loop
    var t0 = performance.now();
    var _loop = function loop(now) {
      var dt = clamp((now - t0) / 16.6667, 0.5, 2);
      t0 = now;
      var W = cssW();
      var H = cssH();
      var amplitude = Math.min(W, H) * amplitudeBase;
      var twist = prefersReducedMotion ? 0 : now * 0.0007;
      var repelRadius = Math.min(W, H) * baseRepelRadiusFactor * breakIntensity;
      var repelStrength = baseRepelStrength * breakIntensity;

      // Update base positions (LOCAL space)
      for (var i = 0; i < dots.length; i++) {
        var d = dots[i];
        var t = d.tFrac;
        var x = t * W;
        var theta = t * turns * Math.PI * 2 + twist;
        var yCenter = H * 0.5;
        var yA = yCenter + amplitude * Math.sin(theta);
        var yB = yCenter + amplitude * Math.sin(theta + Math.PI);
        var depthA = Math.cos(theta);
        var depthB = Math.cos(theta + Math.PI);
        d.bx = x;
        if (d.strand === 0) {
          d.by = yA;
          d.depth = depthA;
        } else if (d.strand === 1) {
          d.by = yB;
          d.depth = depthB;
        } else {
          var tau = d.tau || 0.5;
          d.by = yA * (1 - tau) + yB * tau;
          d.depth = depthA * (1 - tau) + depthB * tau;
        }
      }

      // Physics in LOCAL space
      var m = mouseRef.current;
      for (var _i = 0; _i < dots.length; _i++) {
        var _d = dots[_i];
        _d.vx += (_d.bx - _d.x) * springK * dt;
        _d.vy += (_d.by - _d.y) * springK * dt;
        if (m.active) {
          var dx = _d.x - m.x;
          var dy = _d.y - m.y;
          var dist = Math.hypot(dx, dy);
          if (dist < repelRadius) {
            var s = 1 - dist / repelRadius;
            var strength = repelStrength * (s * s);
            var nx = dx / (dist || 1);
            var ny = dy / (dist || 1);
            _d.vx += nx * strength * 8 * dt;
            _d.vy += ny * strength * 8 * dt;
          }
        }
        _d.vx *= Math.pow(damping, dt);
        _d.vy *= Math.pow(damping, dt);
        _d.x += _d.vx * dt;
        _d.y += _d.vy * dt;
      }

      // Move bokeh in LOCAL space
      if (bokehEnabled && bokeh.length) {
        var parallaxX = (m.active ? m.x - W * 0.5 : 0) * 0.002;
        var parallaxY = (m.active ? m.y - H * 0.5 : 0) * 0.002;
        for (var _i2 = 0; _i2 < bokeh.length; _i2++) {
          var p = bokeh[_i2];
          p.x += (p.vx + parallaxX * p.z) * dt;
          p.y += (p.vy + parallaxY * p.z) * dt;
          if (p.x < -10) p.x = W + 10;
          if (p.x > W + 10) p.x = -10;
          if (p.y < -10) p.y = H + 10;
          if (p.y > H + 10) p.y = -10;
        }
      }

      // ---------- render ----------
      var Wc = cssW();
      var Hc = cssH();

      // clear/fill
      if (background === 'transparent') ctx.clearRect(0, 0, Wc, Hc);else {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, Wc, Hc);
      }
      ctx.save();

      // DRAW order: translate in screen space, then rotate around canvas center
      var dxScreen = Wc * (posFrac(position) - 0.5);
      // Adjust offset based on position: for 'left' shift right, for 'right' shift left
      var horizontalOffset = position === 'left' ? Wc * 0.15 // Shift right for left position
      : position === 'right' ? -Wc * 0.15 // Shift left for right position
      : 0; // No offset for center
      ctx.translate(dxScreen + horizontalOffset, 0);
      var cx = Wc * 0.5,
        cy = Hc * 0.5;
      ctx.translate(cx, cy);
      ctx.rotate(angle);
      ctx.translate(-cx, -cy);

      // Bokeh
      if (bokehEnabled && bokeh.length) {
        ctx.save();
        var _iterator = _createForOfIteratorHelper(bokeh),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _p = _step.value;
            ctx.beginPath();
            ctx.globalAlpha = 0.18 + _p.z * 0.22;
            ctx.shadowBlur = (8 + _p.z * 18) * (Wc / 1000);
            ctx.shadowColor = bokehColor;
            ctx.fillStyle = bokehColor;
            ctx.arc(_p.x, _p.y, _p.r, 0, Math.PI * 2);
            ctx.fill();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ctx.restore();
      }

      // DNA dots (depth-sorted)
      var order = dots.slice().sort(function (p, q) {
        return p.depth - q.depth;
      });
      var _iterator2 = _createForOfIteratorHelper(order),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _d2 = _step2.value;
          var baseSize = 2 + (_d2.depth + 1) / 2 * dotSize;
          var size = (_d2.strand === 2 ? baseSize * rungDotScale : baseSize) * (Wc / 1000);
          var alpha = 0.4 + (_d2.depth + 1) / 2 * 0.6;
          ctx.beginPath();
          ctx.arc(_d2.x, _d2.y, size, 0, Math.PI * 2);
          ctx.fillStyle = _d2.strand === 0 ? dotColorA : _d2.strand === 1 ? dotColorB : rungColor || '#CED5EA';
          ctx.globalAlpha = alpha;
          ctx.fill();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      ctx.globalAlpha = 1;
      ctx.restore();
      rafRef.current = requestAnimationFrame(_loop);
    };
    rafRef.current = requestAnimationFrame(_loop);
    return function () {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      window.removeEventListener('resize', handleResize);
      if (ro) {
        try {
          ro.unobserve(wrapper);
          ro.disconnect();
        } catch (_unused) {
          /* noop */
        }
      }
      canvas.removeEventListener('mousemove', onMove);
      canvas.removeEventListener('mouseleave', onLeave);
      canvas.removeEventListener('touchstart', onMove);
      canvas.removeEventListener('touchmove', onMove);
      canvas.removeEventListener('touchend', onLeave);
      canvas.removeEventListener('touchcancel', onLeave);
    };
  }, [background, dotColorA, dotColorB, rungColor, height, rungs, width, breakIntensity, springKProp, dampingProp, aspectRatio, bokehEnabled, bokehCount, bokehColor, rungDotCount, rungDotScale, rotationDeg, position, amplitudeBase, turns, dotSize, prefersReducedMotion]);
  return wp.element.createElement("div", {
    ref: wrapperRef,
    style: {
      position: 'relative',
      width: width ? width : '100%',
      height: height ? height : '100%',
      overflow: 'hidden',
      background: background
    }
  }, wp.element.createElement("canvas", {
    ref: canvasRef,
    "aria-label": "Interactive DNA helix visualization"
  }));
};
export default InteractiveDNA;